import e from'@mui/material/MenuItem';var m=e;export{m as MenuItem};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map